import styled, { keyframes, css } from 'styled-components';

const TEAL = '#2B4E56';
const TEXT_DIM = '#7A8C92';
const CORAL = '#F5A687';
const BG_ACTIVE = '#FFEFE6';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const containerPlacements = {
  right: css`
    left: 100%;
    top: 0;
    margin-left: 12px;
  `,
  below: css`
    top: 100%;
    left: 0;
    margin-top: 10px;
  `,
};

export const PopupContainer = styled.div`
  position: absolute;
  ${({ $placement = 'right' }) => containerPlacements[$placement] || containerPlacements.right};
  width: 240px;
  background: #ffffff;
  color: ${TEAL};
  border-radius: 6px;
  box-shadow: 0 8px 24px rgba(15, 30, 35, 0.18), 0 2px 4px rgba(15, 30, 35, 0.08);
  padding: 12px 0 8px;
  z-index: 80;
  animation: ${fadeIn} 120ms ease;

  &:focus {
    outline: none;
  }
`;

const tailPlacements = {
  right: css`
    left: -6px;
    top: 16px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid #ffffff;
    filter: drop-shadow(-1px 0 0 rgba(15, 30, 35, 0.06));
  `,
  below: css`
    top: -6px;
    left: 14px;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #ffffff;
    filter: drop-shadow(0 -1px 0 rgba(15, 30, 35, 0.06));
  `,
};

export const Tail = styled.span`
  position: absolute;
  width: 0;
  height: 0;
  ${({ $placement = 'right' }) => tailPlacements[$placement] || tailPlacements.right};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
`;

export const Title = styled.span`
  color: ${CORAL};
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

export const Count = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 6px;
  border-radius: 9px;
  background: #f1ebe8;
  color: ${TEAL};
  font-size: 11px;
  font-weight: 600;
`;

export const Subtitle = styled.div`
  padding: 0 14px;
  margin-top: 2px;
  color: ${TEXT_DIM};
  font-size: 12px;
`;

export const Divider = styled.hr`
  margin: 10px 0;
  border: 0;
  border-top: 1px solid #efe7e3;
`;

export const List = styled.div`
  margin: 0;
  padding: 0;
`;

/* Rendered as a real <a>/<Link> (see index.js) so the browser's own affordances work: right-click
   "Open link in new tab/window", middle-click, and cmd/ctrl-click. It used to be an <li> with an
   onClick handler, which gave the browser nothing to offer. */
export const Item = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  font-size: 13px;
  color: ${TEAL};
  cursor: pointer;
  text-decoration: none;
  text-transform: capitalize;

  ${({ $current }) =>
    $current &&
    css`
      background: ${BG_ACTIVE};
      font-weight: 600;
    `}

  ${({ $active, $current }) =>
    $active &&
    !$current &&
    css`
      background: #f7f2f0;
    `}

  ${({ $active, $current }) =>
    $active &&
    $current &&
    css`
      background: #ffe6d6;
    `}
`;

export const CurrentDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${CORAL};
  flex-shrink: 0;
`;

export const ItemLabel = styled.span`
  flex: 1;
`;

export const Footer = styled.div`
  display: flex;
  gap: 10px;
  padding: 6px 14px 0;
  border-top: 1px solid #efe7e3;
  margin-top: 6px;
  padding-top: 8px;
  color: ${TEXT_DIM};
  font-size: 11px;
`;

export const Hint = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #f1ebe8;
  border-radius: 3px;
  color: ${TEAL};
  font-size: 10px;
  font-family: inherit;
`;
